import styled from "styled-components";
import Step1Img from "../../../assets/images/process/step-1.svg";
import Step2Img from "../../../assets/images/process/step-2.svg";
import Step3Img from "../../../assets/images/process/step-3.svg";
import Step4Img from "../../../assets/images/process/step-4.svg";
import WorkingStepsCard from "../../../common/components/card/WorkingStepsCard";
import Description from "../../../common/components/text/Description";
import H2 from "../../../common/components/text/H2";
import { Theme } from "../../../common/themes/theme";

const Wrapper = styled.div`
  padding: 70px 50px;
  background-color: ${Theme.color.default.white};

  @media (max-width: ${Theme.breakpoints.TABLET_SMALL}px) {
    padding: 50px 20px;
  }
`;

const Heading = styled.div`
  width: 100%;
  max-width: 700px;
  text-align: center;
  margin: 0 auto 50px;

  @media (max-width: 768px) {
    margin-bottom: 40px;
  }
`;

const CardsContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(260px, 1fr));
  gap: 24px;

  @media (max-width: 1200px) {
      gap: 24px;
    grid-template-columns: repeat(2, 1fr);
  }

  @media (max-width: 640px) {
    grid-template-columns: 1fr;
    gap: 20px;
  }
`;

const StepDetails = [
  {
    index: "1",
    title: "Upload CAD file",
    desc: "Easily upload your CAD file to get started with your project.",
    img: Step1Img,
  },
  {
    index: "2",
    title: "Quote & Design Analysis",
    desc: "Receive an instant quote and a detailed design review for your file.",
    img: Step2Img,
  },
  {
    index: "3",
    title: "Order Confirmation",
    desc: "Review and confirm your order details before production begins.",
    img: Step3Img,
  },
  {
    index: "4",
    title: "Parts Shipped",
    desc: "Your parts are manufactured, packaged, and on their way to you.",
    img: Step4Img,
  },
];

function ProgressSection() {
  return (
    <Wrapper>
      <Heading>
        <H2>
          How To <span>Work </span>With Us
        </H2>

        <Description>
          Every component we produce is a testament to our engineering
          standards. From aerospace brackets to medical implant housings —
          tolerances don't lie.
        </Description>
      </Heading>

      <CardsContainer>
        {StepDetails.map((detail, key) => (
          <WorkingStepsCard
            key={key}
            index={detail.index}
            title={detail.title}
            desc={detail.desc}
            img={detail.img}
          />
        ))}
      </CardsContainer>
    </Wrapper>
  );
}

export default ProgressSection;
